/*
 * push-notification-subscription (schema)
 */
import { boolean, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../../constants"
import { users } from "../../user/user.schema"

export const pushNotificationSubscriptions = schema.table(
	"push_notification_subscriptions",
	{
		id: uuid("id").primaryKey().notNull().defaultRandom(),
		userId: uuid("user_id").references(() => users.id, { onDelete: "cascade" }),
		endpoint: varchar("endpoint").notNull().unique(),
		keysP256dh: varchar("keys_p256dh").notNull(),
		keysAuth: varchar("keys_auth").notNull(),
		userVisibleOnly: boolean("user_visible_only").notNull(),
		deviceName: varchar("device_name"),
		expirationTime: timestamp("expiration_time"),
		/* System */
		active: boolean("active").notNull().default(true),
		createdAt: timestamp("created_at").notNull().defaultNow(),
		updatedAt: timestamp("updated_at").notNull().defaultNow(),
		createdBy: uuid("created_by").references(() => users.id, {
			onDelete: "set null",
		}),
		updatedBy: uuid("updated_by").references(() => users.id, {
			onDelete: "set null",
		}),
	},
)
